import { bi } from '#packages/stateManagement';

export const mapDispatchToProps = (dispatch: AnyFixMe) => {
  const sendBi = (evid: number, biParams: Record<string, string>) =>
    dispatch(bi.actions.event({ evid }, biParams));

  return { sendBi };
};
